module.exports = __webpack_public_path__ + "82c64dbab0126f086ed06fcc38137dfc.svg";